import HeaderModal from "../headerModal/headerModal";
import "./InformePDF.css";

const InformePDF = ({ titulo, dissmiss, pdf }) => {
  const blob = base64ToBlob(pdf, "application/pdf");
  const url = URL.createObjectURL(blob);

  function base64ToBlob(base64, type = "application/octet-stream") {
    const binStr = atob(base64);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type: type, title: "Informe" });
  }

  return (
    <div>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} />
      {pdf && (
        <iframe
          title="informe"
          className="ptur-misInformes-PDF"
          src={url}
          type="application/pdf"
        />
      )}
    </div>
  );
};

export default InformePDF;
